import { type FC } from "react";

import { faTrash } from "@fortawesome/pro-duotone-svg-icons/faTrash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { type DocumentFragment, type ProjectFragment } from "@app_schema";

import { useVisible } from "@application/hooks/use_visible";

import { Button } from "@styled/button";
import { Tooltip } from "@styled/tooltip";

import { DocumentDestroyDialog } from "./document_destroy_dialog";

export const DocumentDestroyButton: FC<{
  project: ProjectFragment;
  document: DocumentFragment;
  disabled?: boolean;
  disabledReason?: string;
  cascading?: boolean;
  onDestroy?(): void;
}> = ({
  project,
  document,
  disabled,
  disabledReason,
  cascading,
  onDestroy,
}) => {
  const [visible, onToggle] = useVisible();

  const button = (
    <Button color="rose" onClick={onToggle} disabled={disabled}>
      <FontAwesomeIcon icon={faTrash} /> Delete
    </Button>
  );

  return (
    <>
      {disabled && disabledReason ? (
        <Tooltip tip={disabledReason} placement="bottom">
          {button}
        </Tooltip>
      ) : (
        button
      )}

      {visible && (
        <DocumentDestroyDialog
          project={project}
          document={document}
          cascading={cascading}
          onDestroy={onDestroy}
          onClose={onToggle}
        />
      )}
    </>
  );
};
